import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const BluePinkInOrange = ({
  svgProps,
  hideGrain,
}: {
  svgProps: React.SVGProps<SVGSVGElement>
  hideGrain?: boolean
}) => {
  const uniqueId = useId()
  const maskId = `grainMask-blue-pink-in-orange-${uniqueId}`

  return (
    <svg
      {...svgProps}
      width="1456"
      height="1387"
      viewBox="0 0 1456 1387"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id={`filter0_f_6287_614_${uniqueId}`}
          x="82.5276"
          y="188.05"
          width="989.039"
          height="985.867"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_6287_614"
          />
        </filter>
        <filter
          id={`filter1_f_6287_614_${uniqueId}`}
          x="104.215"
          y="82.7369"
          width="961.269"
          height="958.322"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_6287_614"
          />
        </filter>
        <filter
          id={`filter2_f_6287_614_${uniqueId}`}
          x="216.628"
          y="8.82202"
          width="961.269"
          height="958.322"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_6287_614"
          />
        </filter>

        {/* Mask that matches the exact blurred shapes */}
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter={`url(#filter0_f_6287_614_${uniqueId})`}>
            <ellipse
              cx="577.047"
              cy="680.983"
              rx="156"
              ry="154"
              transform="rotate(-30.7308 577.047 680.983)"
              fill="white"
            />
          </g>
          <g filter={`url(#filter1_f_6287_614_${uniqueId})`}>
            <ellipse
              cx="584.849"
              cy="561.898"
              rx="145"
              ry="143"
              transform="rotate(-30.7308 584.849 561.898)"
              fill="white"
            />
          </g>
          <g filter={`url(#filter2_f_6287_614_${uniqueId})`}>
            <ellipse
              cx="697.263"
              cy="487.983"
              rx="145"
              ry="143"
              transform="rotate(-30.7308 697.263 487.983)"
              fill="white"
            />
          </g>
        </mask>
      </defs>

      {/* Blue ellipse */}
      <g filter={`url(#filter0_f_6287_614_${uniqueId})`}>
        <ellipse
          cx="577.047"
          cy="680.983"
          rx="156"
          ry="154"
          transform="rotate(-30.7308 577.047 680.983)"
          fill="#176AE5"
        />
      </g>

      {/* Pink ellipse */}
      <g filter={`url(#filter1_f_6287_614_${uniqueId})`}>
        <ellipse
          cx="584.849"
          cy="561.898"
          rx="145"
          ry="143"
          transform="rotate(-30.7308 584.849 561.898)"
          fill="#EF91F7"
        />
      </g>

      {/* Orange ellipse */}
      <g filter={`url(#filter2_f_6287_614_${uniqueId})`}>
        <ellipse
          cx="697.263"
          cy="487.983"
          rx="145"
          ry="143"
          transform="rotate(-30.7308 697.263 487.983)"
          fill="#FF824D"
        />
      </g>

      {/* Grain applied with mask that matches the blurred boundaries */}
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
          opacity={0.9}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
